const About = () =>(
    <div className="row justify-content-center align-items-center ">
        <div className="glass pad" style={{ width: "100%", maxWidth: "800px" }}>
          <h2 style={{textAlign:'center'}} >About Me !</h2>
          <div
            className="center"
          >
            <div style={{ padding: "2%", margin: "1%" }}>
              <div>
                <h4>
                Hey there! I’m Sathish 👋
                </h4>
                <p>
                An Android Developer specializing in Java and building high-performance, scalable mobile applications. My expertise lies in creating efficient, user-friendly apps with seamless UI/UX and backend integrations.

<br/>🔹 Core Skills: Android Development (Java), API Integration, Performance Optimization
<br/>🔹 Tech Stack: Java, Kotlin (Exploring), Firebase, REST APIs, SQLite, Jetpack Components
<br/>🔹 Development Focus: Writing clean, maintainable code, optimizing app performance, and implementing modern Android architectures <br/>

I’m passionate about solving real-world problems through technology and constantly improving my skills to build better, faster, and more efficient applications. 🚀
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
)

export default About